// extracted by mini-css-extract-plugin
export default {"expandTriangleIcon":"SubIssuesSummaryToken-module__expandTriangleIcon--_zFQW","SubIssuesSummaryToken":"SubIssuesSummaryToken-module__SubIssuesSummaryToken--qIYQo"};